import * as React from 'react';
import { FC, useId, useState } from 'react';
import { sample } from 'lodash';
import { CampaignView, JackpotView } from 'app/CasinoGames/useJackpotAggregatorCampaignViews';
import { moneyStr } from 'app/helpers/money';
import locales from 'app/CasinoGames/locales';
import { ErrorBoundary } from 'react-error-boundary';

type JackpotViewComponentProps = { jackpotView: JackpotView; currency: string; url: string | null };

const JackpotViewComponent: FC<JackpotViewComponentProps> = ({ jackpotView, currency, url }) => {
  const id = useId();

  return (
    <li className="jm_item" aria-labelledby={id}>
      <a href={`/promo${url}`} target="_blank" rel="noreferrer">
        <div className="jm_name" id={id}>
          {jackpotView.name}
        </div>
        <div className="jm_amount">{moneyStr(jackpotView.current_value, currency)}</div>
      </a>
    </li>
  );
};

type JackpotAggregatorCampaignViewProps = { campaignViews: CampaignView[] };

const JackpotAggregatorCampaign: FC<JackpotAggregatorCampaignViewProps> = ({ campaignViews }) => {
  const [campaignView] = useState(sample(campaignViews));
  const l = locales();

  if (!campaignView) return null;

  return (
    <div className="jackpot-modal jm" style={{ opacity: 0 }}>
      <h2 className="jm_title">{l.jackpot_aggregator_campaigns_text_1}</h2>
      <div className="jm_description">{l.jackpot_aggregator_campaigns_text_2}</div>
      <ul className="jm_list">
        {campaignView.jackpot_views.map((jackpotView) => (
          <JackpotViewComponent
            key={jackpotView.name}
            jackpotView={jackpotView}
            currency={campaignView.currency}
            url={`/promo${campaignView.url}`}
          />
        ))}
      </ul>
      {campaignView.url && (
        <div className="jm_buttons">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href={`/promo${campaignView.url}`} target="_blank" rel="opener">
            {l.jackpot_aggregator_campaigns_details}
          </a>
        </div>
      )}
    </div>
  );
};

const WrappedJackpotAggregatorCampaignView: FC<JackpotAggregatorCampaignViewProps> = (props) => (
  <ErrorBoundary fallback={<div className="error">Error</div>}>
    <JackpotAggregatorCampaign {...props} />
  </ErrorBoundary>
);

export default WrappedJackpotAggregatorCampaignView;
